import { render } from "./SidebarAddStream.vue?vue&type=template&id=fbbf2b64&scoped=true"
import script from "./SidebarAddStream.vue?vue&type=script&setup=true&lang=js"
export * from "./SidebarAddStream.vue?vue&type=script&setup=true&lang=js"

import "./SidebarAddStream.vue?vue&type=style&index=0&id=fbbf2b64&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fbbf2b64"],['__file',"src/components/modals/SidebarAddStream.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "fbbf2b64"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('fbbf2b64', __exports__)) {
    api.reload('fbbf2b64', __exports__)
  }
  
  module.hot.accept("./SidebarAddStream.vue?vue&type=template&id=fbbf2b64&scoped=true", () => {
    api.rerender('fbbf2b64', render)
  })

}


export default __exports__